import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';

export const NewDocumentContainer = styled.div`
  margin: 0 auto;
  width: 580px;
`;

export const FieldContainer = styled(Column)`
  flex: 2;
`;

export const FileRow = styled(Row)<{ disabled: boolean }>`
  padding: 8px 0 8px 10px;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.separatorOnGray : theme.colors.columnHeaders};
`;

export const RemoveFileBtn = styled.div`
  cursor: pointer;
  padding: 10px;
  margin: -10px 0 -10px auto;

  &:not(:hover) {
    opacity: 0.8;
  }
`;

export const Anchor = styled.a`
  color: ${({ theme }) => theme.colors.primary} !important;
  font-weight: 600;
  font-size: 14px;
`;
